import React from 'react';
import "react-router-dom";

import '../functions/player';

export class Lighthouse extends React.Component {
  constructor(props) {
    super(props);

		this.state = {
      left: '0',
      bottom: '0',
    }
  }

	componentWillMount() {
    let coordinates = this.props.coordinates;
    this.setState({
      left: coordinates[0],
      bottom: coordinates[1],
    });
  }

  render() {
    let lighthouseStyling = {
      width: '4.3%',
      left: this.state.left + '%',
      bottom: this.state.bottom + '%',
      transform: 'translate(-70.2%, 37.8%)'
    }
    let lighthouseBeamsStyling = {
      width: '8.6%',
      left: (this.state.left + 2.3) +  '%',
      bottom: (this.state.bottom + 4.3) + '%',
      transform: 'translate(-70.2%, 37.8%)'
    }
    return(
      <div className="entityWrap">
        <img className={`boardElement lighthouse-${ this.props.location }`} alt='Lighthouse' style={lighthouseStyling} src={require("../assets/elements/Lighthouse.svg")}/>
        <img className={`boardElement svg lighthouse-beams-${ this.props.location }`} alt='Lighthouse' style={lighthouseBeamsStyling} src={require("../assets/elements/Lighthouse beams.svg")}/>
      </div>

    )
  }

}



// WEBPACK FOOTER //
// ./src/components/lighthouse.js